import { getArray, httpDelete, post } from '@/api/AxiosUtil'

export function getOrders() {
  return getArray('/api/v3/order/history')
}

export function removeOrderFiles(id) {
  return httpDelete(`/api/v3/order/${id}`)
}
